/*=========================================================================================
  File Name: moduleCompanyGetters.js
  Description: Company Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
	getExcuteSupervisorRolesId: (state) =>
		state.roles.filter((role) => role.name === "SUPERVISOR" || role.name === "EXECUTIVE").map(({id}) => id),
};
